
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRock as ObiRockElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rock.js';
 
 
 

 
 export const ObiRock = createComponent({
   react: React,
   tagName: 'obi-rock',
   elementClass: ObiRockElement,
   events: {
     
   }
  });
 
 